export const ATTENDANCE_LOCATION_PERMISSION_CODES = {
    WEB_ATTENDANCE_LOCATION_LIST: 'WEB_ATTENDANCE_LOCATION_LIST',
    WEB_ATTENDANCE_LOCATION_DETAIL: 'WEB_ATTENDANCE_LOCATION_DETAIL',
    WEB_ATTENDANCE_LOCATION_ADD: 'WEB_ATTENDANCE_LOCATION_ADD',
    WEB_ATTENDANCE_LOCATION_EDIT: 'WEB_ATTENDANCE_LOCATION_EDIT',
    WEB_ATTENDANCE_LOCATION_DELETE: 'WEB_ATTENDANCE_LOCATION_DELETE',
    WEB_ATTENDANCE_LOCATION_IMPORT: 'WEB_ATTENDANCE_LOCATION_IMPORT',
    WEB_ATTENDANCE_LOCATION_EXPORT: 'WEB_ATTENDANCE_LOCATION_EXPORT',
} as const;

